import { render } from "./LandingComp.vue?vue&type=template&id=b14d3bc2"
import script from "./LandingComp.vue?vue&type=script&lang=js"
export * from "./LandingComp.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/new-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__